import React, { useState, useRef, memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Grow } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import KeyboardEventHandler from 'react-keyboard-event-handler'

import {
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
  CloseRounded as CloseIcon,
} from '@material-ui/icons'

import { setChatKeyword } from '../../../redux/keyword/actions'
import SearchField from '../../atoms/inputs/searchField'
import IconButton from '../../atoms/inputs/iconButton'
import Button from '../../atoms/inputs/button'
import Typography from '../../atoms/display/typography'

import useStyles from './chatSearchStyle'

const chatSearch = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [filter, setFilter] = useState(0)
  const [keyword, setKeyword] = useState('')
  const [totalResults, setTotalResults] = useState(0)
  const inputSearchRef = useRef()
  const totalAnchorsRef = useRef(0)
  const currentAnchorRef = useRef(0)
  const size = useSelector((state) => state.preferences)

  const search = () => {
    if (inputSearchRef?.current?.value) {
      dispatch(setChatKeyword(inputSearchRef.current.value))
      setTimeout(() => {
        var x = document.getElementsByClassName(`anchor-chat`)
        for (var i = 0; i < x.length; i++) {
          x[i].style.backgroundColor = theme.palette.highlightSearch
        }
        if (x[0]) {
          x[0].style.backgroundColor = theme.palette.highlightSearchActive
          x[0].scrollIntoView()
        }
      }, 300)
    } else {
      dispatch(setChatKeyword(''))
      setKeyword('')
    }
  }

  const cleanSearch = () => {
    var x = document.querySelectorAll('[class*=anchor-]')
    totalAnchorsRef.current = x.length
    for (var i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = 'transparent'
    }
    dispatch(setChatKeyword(''))
    setKeyword('')
  }

  // TODO: improve it accessing DOM properly
  const getResults = () => {
    const elements =
      filter === 0
        ? document.getElementsByClassName(`anchor-chat`)
        : filter === 1
        ? document.getElementsByClassName(`anchor-insight`)
        : filter === 2
        ? document.getElementsByClassName(`anchor-midia`)
        : filter === 3
        ? document.getElementsByClassName(`anchor-audio`)
        : []

    setTotalResults(elements.length)
    return elements
  }

  const jumpToSearchAnchor = (moviment) => {
    const x = getResults()

    totalAnchorsRef.current = x.length

    for (var i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = theme.palette.highlightSearch
    }
    if (currentAnchorRef.current === 0 && moviment === 'up') {
      currentAnchorRef.current = x.length - 1
    } else if (
      currentAnchorRef.current === x.length - 1 &&
      moviment === 'down'
    ) {
      currentAnchorRef.current = 0
    } else {
      currentAnchorRef.current =
        moviment === 'up'
          ? currentAnchorRef.current - 1
          : currentAnchorRef.current + 1
    }
    if (x[currentAnchorRef.current]) {
      x[currentAnchorRef.current].style.backgroundColor =
        theme.palette.highlightSearchActive
      if (filter > 0) {
        x[currentAnchorRef.current].style.color = '#fff'
      }
      x[currentAnchorRef.current].scrollIntoView()
    }
  }

  useEffect(() => {
    dispatch(setChatKeyword(''))
    cleanSearch()
    getResults()
  }, [filter])

  return (
    <>
      <Grow in={props.open}>
        <div className={classes.root}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexWrap: 'nowrap',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              paddingBottom: 10,
            }}
          >
            <div className={classes.scrollItems}>
              <Button
                variant={filter === 0 ? 'contained' : 'outlined'}
                color="primary"
                border="rounded"
                size="small"
                onClick={() => setFilter(0)}
                style={{ marginRight: 5 }}
              >
                {t('buttons.allMessages')}
              </Button>
              <Button
                variant={filter === 1 ? 'contained' : 'outlined'}
                color="primary"
                border="rounded"
                size="small"
                onClick={() => setFilter(1)}
                style={{ marginRight: 5 }}
              >
                {t('buttons.data')}
              </Button>
              <Button
                variant={filter === 2 ? 'contained' : 'outlined'}
                color="primary"
                border="rounded"
                size="small"
                onClick={() => setFilter(2)}
                style={{ marginRight: 5 }}
              >
                {t('buttons.mediaAndFiles')}
              </Button>
              <Button
                variant={filter === 3 ? 'contained' : 'outlined'}
                color="primary"
                border="rounded"
                size="small"
                onClick={() => setFilter(3)}
                style={{ marginRight: 5 }}
              >
                {t('buttons.audio')}
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 15,
              }}
            >
              <Typography variant="body2">{t('commons.close')}</Typography>
              <IconButton
                style={{ marginLeft: 5 }}
                color="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  dispatch(setChatKeyword(''))
                  props.setOpenSearch(false)
                }}
              >
                <CloseIcon
                  style={{
                    color: theme.palette.primary.main,
                    fontSize: 14,
                    margin: 3,
                  }}
                />
              </IconButton>
            </div>
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexWrap: 'nowrap',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '100%' }}>
              <KeyboardEventHandler
                handleKeys={['up', 'down', 'enter']}
                onKeyEvent={(key) => {
                  if (key === 'enter') {
                    dispatch(setChatKeyword(''))
                    setKeyword('')
                    search()
                  }
                  if (key === 'up') {
                    jumpToSearchAnchor('up')
                  }
                  if (key === 'down') {
                    jumpToSearchAnchor('down')
                  }
                }}
              >
                <SearchField
                  id="field-search"
                  label={t('fields.search.label')}
                  placeholder={t('fields.search.placeHolder')}
                  type="text"
                  color="primary"
                  inputRef={inputSearchRef}
                  variant="outlined"
                  name="searchSkill"
                  shrink={true}
                  fullWidth={true}
                  hide={filter}
                />
                {filter ? (
                  <Typography variant="body1" color="primary">
                    {totalResults > 1
                      ? `${totalResults} ${t('commons.messagesFound')}`
                      : totalResults === 1
                      ? `${totalResults} ${t('commons.messageFound')}`
                      : t('alerts.noMessagesFound')}
                  </Typography>
                ) : null}
              </KeyboardEventHandler>
            </div>
            <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <div style={{ width: 10 }} />
              <IconButton
                color="primary"
                onClick={() => jumpToSearchAnchor('up')}
              >
                <UpIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>
              <div style={{ width: 10 }} />
              <IconButton
                color="primary"
                onClick={() => jumpToSearchAnchor('down')}
              >
                <DownIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>
              {/* {size === 'large' && (
                <>
                  <div style={{ width: 10 }} />
                  <IconButton color="primary" onClick={() => cleanSearch()}>
                    <CloseIcon style={{ color: theme.palette.primary.main }} />
                  </IconButton>
                </>
              )} */}
            </div>
          </div>
        </div>
      </Grow>
    </>
  )
}

export default memo(chatSearch)
